export default __webpack_public_path__ + "static/fall0-17c9a62a5cef2a39fefc4df6ff9b3abe.webp";